import React, { useCallback } from 'react';
import cx from 'classnames';
import { WebMediaplanActions } from 'types/mediaplan';
import Config from 'config';
import { Button } from 'shared/components/common/buttons/Button';
import { localize } from 'shared/components/other';
import {
  actions,
  getWebMediaplanActionUrl,
  getActionTooltipLocaleId,
  getActionLabelLocaleId,
} from './LinkToActionWithWebMediaplan.helpers';
import classes from './LinkToActionWithWebMediaplan.module.scss';

type Props = {
  action: WebMediaplanActions;
  beforeLinkOpen(): void;
  className?: string;
  disabled?: boolean;
  fileId: number;
  mediaplanId: number;
  mediaplanVersionId: number;
};

export const LinkToActionWithWebMediaplan: React.VFC<Props> = (props) => {
  const { action, className, disabled, fileId, mediaplanId, mediaplanVersionId, beforeLinkOpen } = props;
  const act = actions[action];
  const url = getWebMediaplanActionUrl({
    backendUrl: Config.api.cswFrontUrl,
    path: act.url.path,
    mediaplanId,
    mediaplanVersionId,
    fileId: act.url.hasFileIdParam ? fileId : null,
    isImportAMP: act.title === 'import',
  });

  const tooltip = localize(getActionTooltipLocaleId(act.title));
  const label = localize(getActionLabelLocaleId(act.title));

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      (async () => {
        await beforeLinkOpen();
        window.open(url, '_blank', 'noopener,noreferrer');
      })();
    },
    [beforeLinkOpen, url],
  );

  return (
    <Button
      className={cx(classes.root, className)}
      data-test={`link_${act.title}_${fileId}`}
      disabled={disabled}
      icon={`icon icon-${act.icon}`}
      iconPos="right"
      label={label}
      onClick={handleClick}
      tooltip={tooltip}
    />
  );
};

export type { Props as LinkToActionWithWebMediaplanProps };
